import { PageProps } from 'gatsby';
import { ReactNode } from 'react';
import { Layout } from 'components/layout/Layout';
import { PublicLayout } from 'components/layout/PublicLayout';
import { useUser } from 'services/User';

type ResultsLayoutProps = Omit<PageProps, 'children'> & { children?: ReactNode };

// Results always keep the regular app chrome — archives get their file panel inside the page
// (see ArchiveMenu), not a dedicated layout, so the left menu never swaps out or shows a loader.
export const ResultsLayout = ({ children, ...props }: ResultsLayoutProps) => {
    const { user } = useUser();

    if (!user?.isLoggedIn) {
        return <PublicLayout {...props}>{children}</PublicLayout>;
    }

    return <Layout {...props}>{children}</Layout>;
};
